import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className"];
import React, { forwardRef } from 'react';
import { useDropdown, useDropdownClassName } from './hooks';
import { DropdownContainer, DropdownExpansionIndicator, DropdownOptionListContainer, DropdownRoot, DropdownTextInput, DropdownArrow, ExpansionIndicatorContainer } from './style';
import { DROPDOWN_CLASS_PREFIX, DROPDOWN_OPTION_LIST_CONTAINER } from './constants';
import { OptionList } from '../OptionList';
import { useTheme } from '../../styling';
import { DropdownBeforeSection } from './DropdownBeforeSection';
import { PortalToBody } from '../../system/util/PortalToBody';
export var Dropdown = forwardRef(function Dropdown(_ref, ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var theme = useTheme().armor;

  var _useDropdown = useDropdown(props, ref),
      rootProps = _useDropdown.rootProps,
      containerProps = _useDropdown.containerProps,
      textInputProps = _useDropdown.textInputProps,
      portalProps = _useDropdown.portalProps,
      listContainerProps = _useDropdown.listContainerProps,
      arrowProps = _useDropdown.arrowProps,
      optionListProps = _useDropdown.optionListProps,
      dropdownExpansionIndicatorProps = _useDropdown.dropdownExpansionIndicatorProps,
      dropdownBeforeSectionProps = _useDropdown.dropdownBeforeSectionProps,
      disabled = _useDropdown.disabled,
      internalValue = _useDropdown.internalValue,
      open = _useDropdown.open;

  var classOverride = useDropdownClassName(DROPDOWN_CLASS_PREFIX, className, disabled);
  var renderActionItem = React.createElement(ExpansionIndicatorContainer, {
    theme: theme,
    className: classOverride.ExpansionIndicatorContainer
  }, React.createElement(DropdownExpansionIndicator, Object.assign({}, dropdownExpansionIndicatorProps, {
    theme: theme,
    className: classOverride.ExpansionIndicator
  })));
  return React.createElement(DropdownRoot, Object.assign({}, rootProps, {
    className: classOverride.Root,
    theme: theme
  }), React.createElement(DropdownContainer, Object.assign({}, containerProps, {
    className: classOverride.Container,
    theme: theme
  }), React.createElement(DropdownTextInput, Object.assign({}, textInputProps, {
    before: internalValue.length ? React.createElement(DropdownBeforeSection, Object.assign({}, dropdownBeforeSectionProps)) : null,
    after: renderActionItem,
    className: classOverride.TextInput,
    theme: theme
  })), React.createElement(PortalToBody, Object.assign({}, portalProps), open && React.createElement(DropdownOptionListContainer, Object.assign({
    "data-testid": DROPDOWN_OPTION_LIST_CONTAINER
  }, listContainerProps, {
    className: classOverride.OptionListContainer,
    theme: theme
  }), React.createElement(OptionList, Object.assign({}, optionListProps, {
    className: classOverride.OptionList
  })), React.createElement(DropdownArrow, Object.assign({}, arrowProps))))));
});